module.exports = __webpack_public_path__ + "img/5.fb5f58bf.jpg";